/* Small, dependency-free scripts: mobile menu, quantity stepper, variant price, account page. */
(function () {
  document.documentElement.classList.add('js');

  /* Mobile menu */
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.getElementById('site-nav');
  if (toggle && nav) {
    var setOpen = function (open) {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    nav.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  /* Voice search: only shown where the browser supports it */
  var mic = document.querySelector('[data-voice-search]');
  var Speech = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (mic && Speech) {
    mic.hidden = false;
    mic.addEventListener('click', function () {
      var field = document.getElementById('header-search');
      var rec = new Speech();
      rec.lang = document.documentElement.lang || 'en-IN';
      rec.onstart = function () { mic.classList.add('is-listening'); };
      rec.onend = function () { mic.classList.remove('is-listening'); };
      rec.onresult = function (e) {
        field.value = e.results[0][0].transcript;
        field.form.submit();
      };
      try { rec.start(); } catch (err) {}
    });
  }

  /* Quantity stepper (+ / -) */
  document.querySelectorAll('.qty-stepper').forEach(function (box) {
    if (box.hasAttribute('data-cart-qty')) return; /* the cart has its own instant-update code below */
    var input = box.querySelector('input');
    var step = function (d) {
      var v = parseInt(input.value, 10);
      if (isNaN(v)) v = 1;
      input.value = Math.max(1, v + d);
    };
    box.querySelector('[data-qty-minus]').addEventListener('click', function () { step(-1); });
    box.querySelector('[data-qty-plus]').addEventListener('click', function () { step(1); });
  });

  /* Show the price (and discount) of the selected variant */
  var select = document.querySelector('[data-variant-select]');
  if (select) {
    select.addEventListener('change', function () {
      document.querySelectorAll('.price-set').forEach(function (el) {
        el.hidden = el.getAttribute('data-variant') !== select.value;
      });
    });
  }

  /* Wishlist: product handles saved in this browser (localStorage) */
  var WK = 'infuzing_wishlist';
  var wishGet = function () {
    try { return JSON.parse(localStorage.getItem(WK) || '[]'); } catch (e) { return []; }
  };
  var wishSet = function (list) {
    try { localStorage.setItem(WK, JSON.stringify(list)); } catch (e) {}
    wishRefresh();
  };
  var wishRefresh = function () {
    var list = wishGet();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-wishlist-toggle')) > -1 ? 'true' : 'false');
    });
  };
  var wishAdd = function (h) { var l = wishGet(); if (l.indexOf(h) < 0) { l.push(h); wishSet(l); } };
  var wishRemove = function (h) { wishSet(wishGet().filter(function (x) { return x !== h; })); };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wishlist-toggle]');
    if (t) {
      e.preventDefault();
      var h = t.getAttribute('data-wishlist-toggle');
      if (wishGet().indexOf(h) > -1) wishRemove(h); else wishAdd(h);
      return;
    }
    var m = e.target.closest('[data-move-to-wishlist]');
    if (m && !m.closest('[data-cart-root]')) {
      wishAdd(m.getAttribute('data-move-to-wishlist'));
      window.location.href = m.getAttribute('data-remove-url');
    }
  });

  var formatMoney = function (cents, fmt) {
    var v = cents / 100;
    return (fmt || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en-IN');
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      return v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  };
  var setCartCount = function () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
        el.hidden = c.item_count === 0;
      });
    }).catch(function () {});
  };

  /* Cart: totals update instantly; the change is saved to the store in the background */
  var cartRoot = document.querySelector('[data-cart-root]');
  if (cartRoot) {
    var cartFmt = cartRoot.getAttribute('data-money-format');
    var cartForm = cartRoot.querySelector('[data-cart-form]');
    var timers = {};
    var wanted = {};
    var queue = Promise.resolve();

    var cartLines = function () { return cartRoot.querySelectorAll('[data-cart-line]'); };
    var setText = function (sel, text) {
      cartRoot.querySelectorAll(sel).forEach(function (n) { n.textContent = text; });
    };
    var recalc = function () {
      var count = 0, total = 0, mrp = 0;
      cartLines().forEach(function (line) {
        var q = parseInt(line.querySelector('input').value, 10) || 0;
        var unit = +line.getAttribute('data-unit'), unitMrp = +line.getAttribute('data-mrp');
        count += q; total += unit * q; mrp += unitMrp * q;
        line.querySelector('[data-line-total]').textContent = formatMoney(unit * q, cartFmt);
        var cmp = line.querySelector('[data-line-compare]');
        if (cmp) { cmp.hidden = !(unitMrp > unit); cmp.textContent = formatMoney(unitMrp * q, cartFmt); }
      });
      setText('[data-cart-items]', count + ' item' + (count === 1 ? '' : 's'));
      setText('[data-cart-total]', formatMoney(total, cartFmt));
      setText('[data-cart-mrp]', formatMoney(mrp, cartFmt));
      setText('[data-cart-save]', formatMoney(Math.max(0, mrp - total), cartFmt));
      var row = cartRoot.querySelector('[data-cart-save-row]');
      if (row) row.hidden = !(mrp > total);
      document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = count; n.hidden = count === 0; });
      var empty = cartLines().length === 0;
      cartRoot.querySelector('[data-cart-empty]').hidden = !empty;
      cartRoot.querySelector('[data-cart-full]').hidden = empty;
    };

    var send = function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); }).then(function (cart) {
        /* Use the store's numbers, e.g. if stock limited the quantity */
        cart.items.forEach(function (it) {
          var line = cartRoot.querySelector('[data-cart-line][data-key="' + it.key + '"]');
          if (!line) return;
          line.setAttribute('data-unit', it.final_price);
          if (!timers[it.key]) line.querySelector('input').value = it.quantity;
        });
        recalc();
        setText('[data-cart-total]', formatMoney(cart.total_price, cartFmt));
      }).catch(function () { window.location.reload(); });
    };
    var schedule = function (key, qty, delay) {
      wanted[key] = qty;
      clearTimeout(timers[key]);
      timers[key] = setTimeout(function () {
        delete timers[key];
        queue = queue.then(function () { return send(key, wanted[key]); });
      }, delay);
    };
    var setQty = function (line, qty) {
      var key = line.getAttribute('data-key');
      qty = Math.max(0, qty);
      line.querySelector('input').value = qty;
      if (qty === 0) line.remove(); /* gone straight away */
      recalc();
      schedule(key, qty, 250);
    };

    cartRoot.addEventListener('click', function (e) {
      var line = e.target.closest('[data-cart-line]');
      if (!line) return;
      var input = line.querySelector('input');
      var cur = parseInt(input.value, 10) || 0;
      if (e.target.closest('[data-qty-minus]')) { setQty(line, cur - 1); return; }
      if (e.target.closest('[data-qty-plus]')) { setQty(line, cur + 1); return; }
      if (e.target.closest('[data-remove-line]')) { e.preventDefault(); setQty(line, 0); return; }
      var mv = e.target.closest('[data-move-to-wishlist]');
      if (mv) { wishAdd(mv.getAttribute('data-move-to-wishlist')); setQty(line, 0); }
    });
    cartRoot.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty] input');
      if (!input) return;
      var line = input.closest('[data-cart-line]');
      setQty(line, parseInt(input.value, 10) || 0);
    });
    /* Check out: save anything still waiting, then go to checkout */
    if (cartForm) {
      cartForm.addEventListener('submit', function (e) {
        e.preventDefault();
        Object.keys(timers).forEach(function (key) {
          clearTimeout(timers[key]); delete timers[key];
          queue = queue.then(function () { return send(key, wanted[key]); });
        });
        queue = queue.then(function () { window.location.href = '/checkout'; });
      });
    }
  }

  /* Sign-in gate: send signed-out visitors to Shopify's sign-in once, then show buttons (no endless loop) */
  var signedIn = document.querySelector('[data-signed-in]');
  if (signedIn) {
    try {
      Object.keys(sessionStorage).forEach(function (k) { if (k.indexOf('infuzing_gate_') === 0) sessionStorage.removeItem(k); });
    } catch (e) {}
  }
  var gate = document.querySelector('[data-signin-gate]');
  if (gate) {
    var gateKey = 'infuzing_gate_' + location.pathname;
    var already = false;
    try { already = !!sessionStorage.getItem(gateKey); } catch (e) {}
    if (!already) {
      try { sessionStorage.setItem(gateKey, '1'); } catch (e) {}
      window.location.replace(gate.getAttribute('data-login-url'));
    } else {
      var msg = gate.querySelector('[data-gate-message]');
      var fb = gate.querySelector('[data-gate-fallback]');
      if (msg) msg.textContent = 'Please sign in or create an account to continue.';
      if (fb) fb.hidden = false;
    }
  }
  /* Prefill forms from a link, e.g. /pages/returns?order=1001 or /pages/feedback?order=1001&product=Name&rating=5 */
  var query = new URLSearchParams(window.location.search);
  document.querySelectorAll('[data-prefill]').forEach(function (el) {
    var v = query.get(el.getAttribute('data-prefill'));
    if (!v) return;
    if (el.type === 'radio') { if (el.value === v) el.checked = true; } else { el.value = v; }
  });
  /* Product photos: arrows, swipe (native scrolling), thumbnails, keyboard */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-gallery-track]');
    var prev = g.querySelector('[data-gallery-prev]');
    var next = g.querySelector('[data-gallery-next]');
    var count = g.querySelector('[data-gallery-count]');
    var thumbs = g.querySelectorAll('[data-gallery-thumb]');
    var n = track.children.length;
    if (n < 2 || !prev || !next) return;
    var index = function () { return Math.round(track.scrollLeft / track.clientWidth); };
    var go = function (i) {
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      setTimeout(sync, 450);
    };
    var sync = function () {
      var i = index();
      if (count) count.textContent = (i + 1) + ' / ' + n;
      prev.disabled = i === 0;
      next.disabled = i === n - 1;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    };
    prev.addEventListener('click', function () { go(index() - 1); });
    next.addEventListener('click', function () { go(index() + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    track.addEventListener('scroll', sync);
    track.addEventListener('scrollend', sync);
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
    });
    window.addEventListener('resize', function () { track.scrollLeft = index() * track.clientWidth; sync(); });
    sync();
  });
  /* Hero slideshow: changes picture every few seconds. Pauses on hover/focus and when the tab is hidden. No autoplay if the visitor asked for reduced motion. */
  document.querySelectorAll('[data-slideshow]').forEach(function (box) {
    var slides = box.querySelectorAll('.slideshow__slide');
    var dots = box.querySelectorAll('[data-slide-dot]');
    if (slides.length < 2) return;
    var delay = Math.max(2000, parseInt(box.getAttribute('data-interval'), 10) || 5000);
    var current = 0, timer = null;
    var show = function (i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === current ? 'true' : 'false'); });
    };
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
    var start = function () {
      stop();
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { show(current + 1); }, delay);
    };
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', start);
    box.addEventListener('focusin', stop);
    box.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  });
  /* Wishlist page */
  var wishList = document.querySelector('[data-wishlist-list]');
  if (wishList) {
    var fmt = wishList.getAttribute('data-money-format');
    var wishEmpty = document.querySelector('[data-wishlist-empty]');
    var wishTotal = document.querySelector('[data-wishlist-total]');
    var el = function (tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text) n.textContent = text;
      return n;
    };
    var card = function (p) {
      var art = el('article', 'product-card wish-card');
      var link = el('a', 'product-card__link');
      link.href = p.url;
      var media = el('div', 'product-card__media');
      if (p.featured_image) {
        var img = new Image();
        img.src = p.featured_image.replace(/(\.\w+)(\?|$)/, '_480x$1$2');
        img.alt = p.title; img.loading = 'lazy';
        media.appendChild(img);
      } else { media.appendChild(el('div', 'placeholder')); }
      link.appendChild(media);
      link.appendChild(el('h3', 'product-card__title', p.title));
      if (p.type) link.appendChild(el('p', 'muted wish-card__type', p.type));
      var price = el('p', 'product-card__price');
      if (p.compare_at_price > p.price) price.appendChild(el('s', 'price__compare', formatMoney(p.compare_at_price, fmt)));
      price.appendChild(el('span', 'price__now', formatMoney(p.price, fmt)));
      link.appendChild(price);
      art.appendChild(link);

      var x = el('button', 'wish-btn wish-remove', '×');
      x.type = 'button'; x.setAttribute('aria-label', 'Remove ' + p.title + ' from wishlist');
      x.addEventListener('click', function () { wishRemove(p.handle); renderWishlist(); });
      art.appendChild(x);

      var variant = p.variants.filter(function (v) { return v.available; })[0];
      var action;
      if (!variant) { action = el('span', 'wish-card__move is-disabled', 'Sold out'); }
      else if (p.variants.length > 1) { action = el('a', 'wish-card__move', 'Choose options'); action.href = p.url; }
      else {
        action = el('button', 'wish-card__move', 'Move to cart'); action.type = 'button';
        action.addEventListener('click', function () {
          action.disabled = true;
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variant.id, quantity: 1 }) })
            .then(function (r) { if (!r.ok) throw new Error(); wishRemove(p.handle); renderWishlist(); setCartCount(); })
            .catch(function () { action.disabled = false; action.textContent = 'Try again'; });
        });
      }
      art.appendChild(action);
      return art;
    };
    var renderWishlist = function () {
      var handles = wishGet();
      wishTotal.textContent = handles.length ? '(' + handles.length + ' item' + (handles.length === 1 ? '' : 's') + ')' : '';
      wishEmpty.hidden = handles.length > 0;
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        wishList.innerHTML = '';
        products.forEach(function (p, i) {
          if (p) wishList.appendChild(card(p)); else wishRemove(handles[i]);
        });
      });
    };
    renderWishlist();
  }
  wishRefresh();

  /* Profile dropdown: close on outside click or Escape */
  var drop = document.querySelector('[data-account-dropdown]');
  if (drop) {
    document.addEventListener('click', function (e) { if (!drop.contains(e.target)) drop.removeAttribute('open'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drop.removeAttribute('open'); });
  }

  /* Account page tabs (also opened by links like /account#orders) */
  var tabs = document.querySelector('[data-account-tabs]');
  if (tabs) {
    var panels = document.querySelectorAll('[data-panel]');
    var show = function (name) {
      tabs.querySelectorAll('button').forEach(function (b) {
        b.setAttribute('aria-selected', b.getAttribute('data-tab') === name ? 'true' : 'false');
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== name; });
    };
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-tab]');
      if (b) show(b.getAttribute('data-tab'));
    });
    var fromHash = function () {
      var h = location.hash.replace('#', '');
      show(h === 'details' || h === 'help' ? h : 'orders');
    };
    window.addEventListener('hashchange', fromHash);
    fromHash();
  }

  /* Profile photo. Saved in this browser only (localStorage). */
  var avatar = document.querySelector('[data-avatar]');
  if (avatar) {
    var key = avatar.getAttribute('data-key');
    var img = avatar.querySelector('.avatar__img');
    var fallback = avatar.querySelector('.avatar__default');
    var input = document.querySelector('[data-avatar-input]');
    var remove = document.querySelector('[data-avatar-remove]');
    var read = function () { try { return localStorage.getItem(key); } catch (e) { return null; } };
    var write = function (v) {
      try { if (v) localStorage.setItem(key, v); else localStorage.removeItem(key); } catch (e) {}
    };
    var render = function () {
      var src = read();
      img.hidden = !src;
      fallback.hidden = !!src;
      if (src) img.src = src;
      if (remove) remove.hidden = !src;
    };
    if (input) {
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file) return;
        var reader = new FileReader();
        reader.onload = function () {
          var pic = new Image();
          pic.onload = function () {
            var size = 256, c = document.createElement('canvas');
            c.width = c.height = size;
            var s = Math.min(pic.width, pic.height);
            c.getContext('2d').drawImage(pic, (pic.width - s) / 2, (pic.height - s) / 2, s, s, 0, 0, size, size);
            write(c.toDataURL('image/jpeg', 0.85));
            render();
          };
          pic.src = reader.result;
        };
        reader.readAsDataURL(file);
      });
    }
    if (remove) remove.addEventListener('click', function () { write(null); render(); });
    render();
  }

  /* Login / Register page: tabs, show-password eye, confirm-password check */
  var auth = document.querySelector('[data-auth]');
  if (auth) {
    var showAuth = function (name) {
      auth.querySelectorAll('[role="tab"][data-auth-tab]').forEach(function (b) {
        b.setAttribute('aria-selected', b.getAttribute('data-auth-tab') === name ? 'true' : 'false');
      });
      auth.querySelectorAll('[data-auth-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-auth-panel') !== name;
      });
    };
    auth.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-auth-tab]');
      if (tab) { showAuth(tab.getAttribute('data-auth-tab')); return; }
      var eye = e.target.closest('[data-toggle-password]');
      if (eye) {
        var field = eye.parentNode.querySelector('input');
        var show = field.type === 'password';
        field.type = show ? 'text' : 'password';
        eye.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
      }
    });
    var regForm = document.getElementById('register-form');
    if (regForm) {
      regForm.addEventListener('submit', function (e) {
        var pw = regForm.querySelector('#reg-password').value;
        var cf = regForm.querySelector('#reg-confirm').value;
        var err = regForm.querySelector('[data-register-error]');
        var msg = '';
        if (pw.length < 5) msg = 'Choose a password of at least 5 characters.';
        else if (pw !== cf) msg = 'The two passwords do not match.';
        if (msg) { e.preventDefault(); err.textContent = msg; err.hidden = false; err.scrollIntoView({ block: 'nearest' }); }
      });
    }
  }
  /* Address form: country -> state list */
  document.querySelectorAll('[data-country]').forEach(function (country) {
    var form = country.closest('form');
    var province = form.querySelector('[data-province]');
    var wrap = form.querySelector('[data-province-wrap]');
    var fill = function (selected) {
      var opt = country.options[country.selectedIndex];
      var list = [];
      try { list = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (e) {}
      province.innerHTML = '';
      list.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0]; o.textContent = p[1];
        if (selected && (selected === p[0] || selected === p[1])) o.selected = true;
        province.appendChild(o);
      });
      wrap.hidden = list.length === 0;
    };
    var d = country.getAttribute('data-default');
    if (d) country.value = d;
    fill(province.getAttribute('data-default'));
    country.addEventListener('change', function () { fill(); });
  });
})();
